/* ==========================================================================
   Recently Viewed LNT
   - Enregistre le produit actuel dans localStorage à chaque visite produit
   - Affiche les derniers produits consultés (hors produit actuel)
   - Fetch le JSON des produits pour construire les cartes
   ========================================================================== */

(function () {
  'use strict';

  const STORAGE_KEY = 'lnt_recently_viewed';
  const MAX_STORED = 20; // on en stocke 20 max, on en affiche 4-10 selon config

  /* ---------- STORAGE ---------- */

  function getStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // quota dépassé ou localStorage désactivé : on ignore
    }
  }

  function trackProduct(handle) {
    if (!handle) return;
    let list = getStored();
    // On retire le handle s'il existe déjà (pour le remettre en tête)
    list = list.filter(function (h) { return h !== handle; });
    // On ajoute en tête
    list.unshift(handle);
    // On limite la taille
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    setStored(list);
  }

  /* ---------- TRACKING : on s'inscrit sur toute page produit ---------- */

  // Détecte si on est sur une page produit via le handle dans l'URL Shopify
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  const currentHandle = match ? match[1] : null;
  if (currentHandle) {
    trackProduct(currentHandle);
  }

  /* ---------- RENDU DES CARTES ---------- */

  function renderCard(product) {
    const href = product.url || ('/products/' + product.handle);
    const firstImage = product.featured_image || (product.images && product.images[0]) || null;
    const secondImage = product.images && product.images.length > 1 ? product.images[1] : null;

    const isOnSale = product.compare_at_price && product.compare_at_price > product.price;

    const card = document.createElement('a');
    card.className = 'card-lnt';
    card.href = href;
    card.setAttribute('aria-label', product.title);

    const media = document.createElement('div');
    media.className = 'card-lnt__media';

    if (firstImage) {
      const img1 = document.createElement('img');
      img1.className = 'card-lnt__image card-lnt__image--primary';
      img1.src = sizeImage(firstImage, 600);
      img1.srcset = [
        sizeImage(firstImage, 300) + ' 300w',
        sizeImage(firstImage, 450) + ' 450w',
        sizeImage(firstImage, 600) + ' 600w',
        sizeImage(firstImage, 900) + ' 900w'
      ].join(', ');
      img1.sizes = '(min-width: 990px) 25vw, 50vw';
      img1.alt = product.title || '';
      img1.loading = 'lazy';
      media.appendChild(img1);
    }

    if (secondImage) {
      const img2 = document.createElement('img');
      img2.className = 'card-lnt__image card-lnt__image--secondary';
      img2.src = sizeImage(secondImage, 600);
      img2.srcset = [
        sizeImage(secondImage, 300) + ' 300w',
        sizeImage(secondImage, 450) + ' 450w',
        sizeImage(secondImage, 600) + ' 600w'
      ].join(', ');
      img2.sizes = '(min-width: 990px) 25vw, 50vw';
      img2.alt = '';
      img2.loading = 'lazy';
      img2.setAttribute('aria-hidden', 'true');
      media.appendChild(img2);
    }

    if (isOnSale) {
      const badges = document.createElement('div');
      badges.className = 'card-lnt__badges';
      const badge = document.createElement('span');
      badge.className = 'card-lnt__badge card-lnt__badge--sale';
      badge.textContent = 'Promo';
      badges.appendChild(badge);
      media.appendChild(badges);
    }

    card.appendChild(media);

    const body = document.createElement('div');
    body.className = 'card-lnt__body';

    const title = document.createElement('h3');
    title.className = 'card-lnt__title';
    title.textContent = product.title;
    body.appendChild(title);

    const priceWrap = document.createElement('div');
    priceWrap.className = 'card-lnt__price';

    if (isOnSale) {
      const compare = document.createElement('span');
      compare.className = 'card-lnt__price-compare';
      compare.innerHTML = '<s>' + formatMoney(product.compare_at_price) + '</s>';
      priceWrap.appendChild(compare);

      const current = document.createElement('span');
      current.className = 'card-lnt__price-current card-lnt__price-current--sale';
      current.textContent = formatMoney(product.price);
      priceWrap.appendChild(current);
    } else {
      const current = document.createElement('span');
      current.className = 'card-lnt__price-current';
      current.textContent = formatMoney(product.price);
      priceWrap.appendChild(current);
    }

    body.appendChild(priceWrap);
    card.appendChild(body);

    return card;
  }

  /* ---------- HELPERS ---------- */

  // Redimensionne une URL image Shopify (ajoute ?width=X ou _WIDTHx)
  function sizeImage(src, width) {
    if (!src) return '';
    // Nouvelle API Shopify : paramètre ?width=
    if (src.indexOf('cdn.shopify.com') !== -1 || src.indexOf('/cdn/shop/') !== -1) {
      const sep = src.indexOf('?') !== -1 ? '&' : '?';
      // Retire un width existant pour éviter les doublons
      const cleaned = src.replace(/([?&])width=\d+/, '$1').replace(/&&/g, '&').replace(/\?&/, '?');
      return cleaned + sep + 'width=' + width;
    }
    return src;
  }

  // Format prix : Shopify renvoie le prix en centimes (ex: 2999 → 29,99 €)
  // On utilise le format français EUR par défaut. Compatible avec LNT.
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    const value = cents / 100;
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  /* ---------- AFFICHAGE DE LA SECTION ---------- */

  document.querySelectorAll('.recently-viewed-lnt').forEach(function (section) {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const currentProductId = section.dataset.currentProductId || '';
    const limit = parseInt(section.dataset.limit, 10) || 4;

    // Récupère les handles stockés, exclut le produit actuel (via handle dans l'URL)
    let handles = getStored();
    if (currentHandle) {
      handles = handles.filter(function (h) { return h !== currentHandle; });
    }
    handles = handles.slice(0, limit);

    if (handles.length === 0) {
      // Aucun produit à afficher : on laisse la section cachée (hidden)
      return;
    }

    // Fetch tous les produits en parallèle
    const promises = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      // Filtre les fetchs qui ont échoué ou produits supprimés
      const valid = products.filter(function (p) {
        return p && String(p.id) !== String(currentProductId);
      });

      if (valid.length === 0) return;

      // Rend les cartes dans l'ordre des handles
      valid.forEach(function (product) {
        grid.appendChild(renderCard(product));
      });

      // Révèle la section
      section.hidden = false;
    });
  });
})();
